/* eslint-disable */
import React, { Component } from "react";
import { OverlayTrigger, Tab, Popover } from "react-bootstrap";
import { 
  Tooltip, 
  CircularProgress, 
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
  Box
} from "@mui/material";
import { CSSTransition } from "react-transition-group";
import { Helmet } from "react-helmet-async";
import { toast } from "react-toastify";
import LoadingBar from "react-top-loading-bar";
import * as Icon from "react-feather";
import "./taps.css";
import moment from "moment-timezone";
import WithRouter from "../../HOC/RouterWrapper";
import HorizontalDropdownMenu from "../../components/global/HorizontalDropdown";

import { ReactComponent as RefreshIcon } from "../../assets/img/icons/refresh.svg";
import { ReactComponent as DetailsIcon } from "../../assets/img/icons/details.svg";
import { ReactComponent as StopIcon } from "../../assets/img/icons/StopIcon.svg";
import { ReactComponent as CancelIcon } from "../../assets/img/icons/CancelIcon.svg";
import { ReactComponent as SettingsIcon } from "../../assets/img/icons/SettingsIcon.svg";
import { ReactComponent as PlayIcon } from "../../assets/img/icons/PlayIcon.svg";
import { ReactComponent as OptionsIcon } from "../../assets/img/icons/OptionsIcon.svg";
import { ReactComponent as FailedIcon } from "../../assets/img/icons/failed.svg";
import { ReactComponent as SuccessIcon } from "../../assets/img/icons/success.svg";
import { ReactComponent as QueuedIcon } from "../../assets/img/icons/queed.svg";
import runningIcon from "../../assets/img/icons/running.json";
import Lottie from "lottie-react";

import SearchJobs from "../jobs/SearchJobs";
import TapCreatorForm from "../../components/DagCreators/TapCreatorForm";
import DagHistory from "../jobs/DagHistory";
import { fetchLastRuns } from "../functions.js";
import djlogo from "./djlogo.svg"; // Import the SVG file stored in src/pages
import airbytelogo from "./airbyte.png"; // Import the SVG file stored in src/pages
import fivetranlogo from "./fivetran.png"; // Import the SVG file stored in src/pages
import Table from "../../components/global/Table/index.js";
import TablePagination from "../../components/global/Table/Pagination.js";
import {
  createFivetranTapService,
  deleteConnectorService,
  deleteDagService,
  discoverSchemaService,
  getGACustomReportsService,
  getMyTapsService,
  saveCustomReportsService,
  stopTaskService,
  triggerAirbyteTapService,
  triggerFivetranService,
} from "../../services/taps.js";
import DeleteConnectorModal from "../../components/Modals/DeleteConnector.js";
import CustomReportsModal from "../../components/Modals/CustomReports.js";

const user = JSON.parse(localStorage.getItem("user"));
var customer_timezone = localStorage.getItem("timezone");

let dropdownSelec = [];

let timestamps = [{ 5: "2 days ago" }];
const timeFormatRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;

class NewTap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      progress: 40,
      loading: false,
      get_dags_status: true,
      spec_details: [],
      global_stream_selected: false,
      global_replicate: false,
      global_selected_sync: "",
      tap_alias: "",
      datasources: [],
      schema_name: "",
      schema: "",
      running_taps: [],
      selected_streams: [],
      global_supportedSyncModes: [],
      custom_reports: [],
      modal_custom_reports: false,
      activeTab: "mytaps",
      historical_dag_runs: [],
      replication_disabled: true,
      dag_pause_statuses: [],
      saving_settings: false,
      loading_connectors: true,
      show_schedule_button: false,
      saving_disabled: true,
      loading_mytaps: true,
      selected_tap: "",
      delete_name: "",
      selected_job: "",
      dag_runs: [],
      streams: [],
      first_load: true,
      last_refresh: timestamps,
      mytasks: [],
      delete_id: "",
      color: "primary",
      embedded_url: false,
      schema_overwritten: false,
      saving: false,
      new_schema: false,
      deleting: false,
      searchConnectorsKeyword: "",
      jobNameFilters: "",
      currentPage: 1,
      perPage: 10,
      isShowingCreateTapForm: false,
      isShowingDagHistoryTable: false,
      sortedColumn: {
        column: "",
        isAsc: true,
      },
      isSearchOpen: false,
      filters: {
        provider: [],
        status: [],
        source: []
      }
    };
    this.isComponentMounted = false; // Flag to track if the component is mounted
  }

  componentDidUpdate(prevProps) {
    const hasQueryParamsChanged =
      this?.props?.router?.location &&
      prevProps?.router?.location &&
      this.props.router.location.search !== prevProps.router.location.search;

    const hasInitialHistoryModalView =
      prevProps.router.location.search.includes("history_modal") ||
      this.props.router.location.search.includes("history_modal");

    if (hasQueryParamsChanged) {
      if (hasInitialHistoryModalView) {
        this.showInitialHistoryModal(prevProps);
      } else {
        this.fetchInitialTapData();
      }
    }
  }

  componentDidMount() {
    this.isComponentMounted = true;
    this.fetchInitialTapData();
  }

  handleStopTask = async (display_name, datajolt_task_id) => {
    this.setState({ stopping: true, progress: 80 });

    const isSuccess = await stopTaskService(display_name, datajolt_task_id);

    if (isSuccess) {
      this.setState((prevState) => {
        const updatedDAGs = prevState.mytasks.map((dag) =>
          dag.datajolt_task_id === datajolt_task_id
            ? { ...dag, status: "canceled" }
            : dag
        );
        return { ...prevState, DAGs: updatedDAGs };
      });
    }
    this.setState({ progress: 100, stopping: false });
  };

  setSelectedTapData = (data) => this.setState(data);

  getTargetDAGData = () => {
    const history_modal = new URLSearchParams(window.location.search).get(
      "history_modal"
    );
    const targetDAG = this.state.mytasks.find((DAG) => DAG.id == history_modal);
    console.log("history_modal");
    console.log(targetDAG);
    return targetDAG;
  };

  showInitialHistoryModal = (prevProps) => {
    //prevProps to extract queryParams from pervious render

    if (
      prevProps.router.location.search.includes("history_modal") &&
      !this.props.router.location.search.includes("history_modal")
    ) {
      this.setState({
        isShowingDagHistoryTable: false,
        historical_runs_available: false,
        modal_history: false,
      });
    }

    if (
      !prevProps.router.location.search.includes("history_modal") &&
      this.props.router.location.search.includes("history_modal")
    ) {
      if (this.getTargetDAGData()) {
        this.toggleHistoryDagTable();
      }
    }
  };

  componentWillUnmount = () => {
    this.fetchDAGLastRunsTimerMounted = false;
    this.isComponentMounted = false;
    clearTimeout(this.fetchDAGLastRunsTimeout);
  };

  toggleHistoryDagTable = () => {
    this.setState({
      isShowingDagHistoryTable: !this.state.isShowingDagHistoryTable,
    });
  };

  createFivetranTap = async (
    connector_id,
    connector_name,
    schema,
    tap_alias
  ) => {
    this.setState({ progress: 40 });

    const isSuccess = await createFivetranTapService(
      connector_name,
      tap_alias,
      connector_id,
      schema
    );

    if (isSuccess) {
      this.getMyTaps();
    }
    this.setState({ progress: 100 });
  };

  fetchInitialTapData = async () => {
    let id = new URLSearchParams(window.location.search).get("id");
    let details = new URLSearchParams(window.location.search).get("details");
    let edit_tap = new URLSearchParams(window.location.search).get("edit_tap");
    let isEditingReport = new URLSearchParams(window.location.search).get(
      "custom_reports"
    );

    if (
      edit_tap &&
      edit_tap === this.state.selected_for_edit &&
      !isEditingReport
    ) {
      return;
    }

    if (
      edit_tap &&
      edit_tap === this.state.selected_for_edit &&
      isEditingReport
    ) {
      this.getGACustomReports();
      return;
    }
    if (id) {
      let tap_alias = details.split("___")[2];
      let connector_name = details.split("___")[1];
      let schema = details.split("___")[0];
      this.createFivetranTap(id, connector_name, schema, tap_alias);
    } else if (edit_tap) {
      this.setState({ selected_for_edit: edit_tap });
      this.toggleCreateTapForm();
      await this.getMyTaps();
      console.log(this.state.mytasks);
      let item = this.state.mytasks.find((item) => item.id === edit_tap);
      if (item) {
        let { connectionID, logo, sourceID, subtype } = item;
        this.setState({
          connection_id: connectionID,
          source_ID: sourceID,
          selected_tap: subtype,
          logo: logo,
          selected_for_edit: edit_tap,
          selected_source_ID: sourceID,
        });

        if (isEditingReport) {
          this.getGACustomReports();
        }
      }
    } else {
      this.setState({
        connection_id: "",
        source_ID: "",
        selected_tap: "",
        logo: "",
        selected_for_edit: "",
        isShowingCreateTapForm: false,
      });
      await this.getMyTaps();

      if (this.getTargetDAGData()) {
        this.toggleHistoryDagTable();
      }
    }
  };

  getGACustomReports = async () => {
    this.setState({ custom_reports: [] });

    const response = await getGACustomReportsService(
      this.state.selected_source_ID,
      this.state.selected_for_edit
    );

    if (response) {
      const { specs, window_in_days, custom_reports } = response;

      this.setState({
        specs,
        window_in_days,
        custom_reports,
        modal_custom_reports: true,
      });
    }
  };

  calculateTotalPages = () => {
    const filteredLength = this.state.mytasks.filter((DAG) =>
      this.filterJobNames(DAG) &&
      this.filterByColumn(DAG, "provider", this.state.filters.provider) &&
      this.filterByColumn(DAG, "source", this.state.filters.source) && 
      this.filterByColumn(DAG, "status", this.state.filters.status)
    ).length;
    return filteredLength ? Math.ceil(filteredLength / this.state.perPage) : 1;
  };

  paginateArray = (
    array,
    activePage = this.state.currentPage,
    perPageCount = this.state.perPage
  ) => {
    const startIndex = (activePage - 1) * perPageCount;
    const endIndex = startIndex + perPageCount;

    return array.slice(startIndex, endIndex);
  };

  goToSchedule = () => {
    this.setState({
      progress: 40,
      saving_settings: true,
      saving_disabled: true,
    });
    this.setState({
      progress: 100,
      saving_settings: false,
      saving_disabled: false,
      activeTab: "schedule",
    });
  };

  toggleDeleteModal = (
    connector_id,
    sourceID,
    logo,
    connector_name,
    datajolt_task_id
  ) => {
    this.setState({
      modal_delete_connector: !this.state.modal_delete_connector,
    });
    if (!this.state.modal_delete_connector) {
      this.setState({
        selected_source_ID: sourceID,
        delete_logo: logo,
        delete_name: connector_name,
        delete_id: connector_id,
        delete_datajolt_task_id: datajolt_task_id,
      });
    }
  };

  getMyTaps = (activeTab = "mytaps") => {
    return new Promise(async (resolve) => {
      this.setState({
        get_dags_status: true,
        global_replicate: false,
        selected_streams: [],
        global_stream_selected: false,
        global_selected_sync: "",
        tap_alias: "",
        loading_mytaps: true,
        progress: 60,
        logs: false,
        streams: [],
        loading_spinner: true,
        replication_disabled: true,
        activeTab: activeTab,
      });

      const response = await getMyTapsService();

      if (response) {
        this.setState({
          show_schedule_button: false,
          mytasks: response.data["dags_list"],
        });
        for (var dag in response.data["dags_list"]) {
          if (
            response.data["dags_list"][dag]["status"] == "running" ||
            response.data["dags_list"][dag]["status"] == "queued"
          ) {
            fetchLastRuns(
              'source.' + response.data["dags_list"][dag]["schema"],
              1,
              this.setState.bind(this),
              () => this.isComponentMounted
            );
          }
          resolve();
        }
      }

      this.setState({ progress: 100, loading_mytaps: false });
    });
  };

  debounce(fn, delay) {
    let timerId;
    return function (...args) {
      if (timerId) {
        clearTimeout(timerId);
      }
      timerId = setTimeout(() => {
        fn(...args);
        timerId = null;
      }, delay);
    };
  }

  updateCustomReport = this.debounce((index, key, e, val) => {
    var current = [...this.state.custom_reports];
    current[index][key] = val || e.target.value;
    this.setState({ custom_reports: current });
  }, 50);

  triggerAirbyteTap = async (dag_id, connection_id, datajolt_task_id) => {
    const isSuccess = await triggerAirbyteTapService(
      dag_id,
      connection_id,
      datajolt_task_id
    );

    if (isSuccess) {
      const nowUTC = moment().utc()?.format("YYYY-MM-DD HH:mm");
      this.setState((prevState) => {
        const updatedMytaps = prevState.mytasks.map((tap) => {
          if (tap.id === dag_id) {
            return {
              ...tap,
              last_started: nowUTC,
              rows: "",
              last_ended: "None",
              status: "running",
            };
          }
          return tap;
        });
        return { mytasks: updatedMytaps };
      });
      fetchLastRuns(
        datajolt_task_id,
        1,
        this.setState.bind(this),
        () => this.isComponentMounted
      );
    }
  };

  toggle_modal_daily_hour = () => {
    this.setState({ modal_daily_hour: !this.state.modal_daily_hour });
  };

  toggle_modal_cron = () => {
    this.setState({ modal_cron: !this.state.modal_cron });
  };

  deleteConnector = async (datajolt_task_id) => {
    this.setState({ deleting: true, color: "primary", progress: 40 });

    const isSuccess = await deleteConnectorService(datajolt_task_id);

    if (isSuccess) {
      this.setState({ modal_delete_connector: false });
      this.getMyTaps();
    }

    this.setState({ deleting: false, progress: 100 });
  };

  deleteDAG = async (datajolt_task_id, alias) => {
    this.setState({ deleting: true, progress: 80 });

    const isSuccess = await deleteDagService(alias, datajolt_task_id);

    if (isSuccess) {
      this.getMyTaps();
    }

    this.setState({
      progress: 100,
      modal_delete_connector: false,
      deleting: false,
    });
  };

  triggerFivetran = async (datajolt_task_id, alias) => {
    this.setState({ progress: 40 });

    const isSuccess = await triggerFivetranService(alias, datajolt_task_id);

    if (isSuccess) {
      const nowUTC = moment().utc()?.format("YYYY-MM-DD HH:mm");
      this.setState((prevState) => {
        const updatedMytaps = prevState.mytasks.map((tap) => {
          if (tap.datajolt_task_id === datajolt_task_id) {
            return {
              ...tap,
              last_started: nowUTC,
              rows: "",
              last_ended: "None",
              status: "running",
            };
          }
          return tap;
        });
        return { mytasks: updatedMytaps };
      });
      fetchLastRuns(
        datajolt_task_id,
        1,
        this.setState.bind(this),
        () => this.isComponentMounted
      );
    }

    this.setState({ progress: 100 });
  };

  validate_custom_reports = () => {
    const isUnique =
      [...new Set(this.state.custom_reports.map((obj) => obj.name))].length ===
      this.state.custom_reports.length;
    if (!isUnique) {
      toast.error("Custom report names have to be unique", { autoClose: 5000 });
      return false;
    } else {
      for (let obj of this.state.custom_reports) {
        let dimensions = [];
        let metrics = [];
        if (!Array.isArray(obj["dimensions"])) {
          dimensions = obj["dimensions"].split(",");
        } else {
          dimensions = obj["dimensions"];
        }
        if (!Array.isArray(obj["metrics"])) {
          metrics = obj["metrics"].split(",");
        } else {
          metrics = obj["metrics"];
        }

        if (obj["name"] == "") {
          toast.error("Your custom report name cannot be empty.", {
            autoClose: 5000,
          });
          return false;
        } else if (dimensions.length == 0 || dimensions == "") {
          toast.error(
            "Your " +
              obj["name"] +
              " custom report dimensions cannot be empty.",
            { autoClose: 5000 }
          );
          return false;
        } else if (metrics.length == 0 || metrics == "") {
          toast.error(
            "Your " + obj["name"] + " custom report metrics cannot be empty.",
            { autoClose: 5000 }
          );
          return false;
        } else if (dimensions.length > 9) {
          toast.error(
            "Your " +
              obj["name"] +
              " custom report cannot have more than 9 dimensions.",
            { autoClose: 5000 }
          );
          return false;
        } else if (metrics.length > 10) {
          toast.error(
            "Your " +
              obj["name"] +
              " custom report cannot have more than 10 metrics.",
            { autoClose: 5000 }
          );
          return false;
        }
      }
      return true;
    }
  };

  discoverOrUpdate = (type) => {
    this.setState({
      global_replicate: false,
      selected_streams: [],
      global_selected_sync: "",
      global_stream_selected: false,
    });
    if (type == "schedule") {
      this.setState({ selected_for_edit: false });
      this.discoverSchema(this.state.selected_source_ID, "schedule");
    }
  };

  discoverSchema = async (sourceID, type) => {
    if (type != "schedule") {
      this.setState({ show_schedule_button: false });
    }
    this.setState({
      streams: [],
      selected_source_ID: sourceID,
      selection_type: type,
      saving_disabled: true,
      progress: 40,
      replication_disabled: false,
      loading_spinner: true,
      activeTab: "data",
    });
    const SelectedTap = {
      sourceID: sourceID,
      tap_name: this.state.selected_tap,
      destination: false,
    };

    const response = await discoverSchemaService(
      SelectedTap,
      this.state.selected_tap
    );

    if (response) {
      this.setState({
        saving_disabled: false,
        streams: response.data["streams"],
        catalogID: response.data["catalogID"],
        global_supportedSyncModes: response.data["global_supportedSyncModes"],
      });
    } else {
      this.setState({ spec_details: [] });
    }

    this.setState({ progress: 100, loading_spinner: false });
  };

  saveCustomReports = async () => {
    if (this.validate_custom_reports()) {
      this.setState({ saving_new_specs: true });
      let current_specs = JSON.parse(JSON.stringify(this.state.specs));
      current_specs.connectionConfiguration.window_in_days =
        this.state.window_in_days;
      current_specs.connectionConfiguration.custom_reports = JSON.stringify(
        this.state.custom_reports
      );

      const isSuccess = await saveCustomReportsService(
        current_specs,
        this.state.selected_for_edit
      );

      if (isSuccess) {
        this.setState({ modal_custom_reports: false });
        this.discoverOrUpdate(this.state.selection_type);
      }

      this.props.router.navigate(
        `/taps/mytaps?edit_tap=${this.state.selected_for_edit}`
      );
      this.setState({ loading: false, saving_new_specs: false });
    }
  };

  saveOrSchedule = (type) => {
    if (type == "schedule") {
      this.goToSchedule();
    }
  };

  handleStateUpdate = (newState) => {
    this.setState(newState);
  };

  toggleCreateTapForm = () => {
    this.setState(
      {
        isShowingCreateTapForm: !this.state.isShowingCreateTapForm,
      },
      () => {
        if (!this.state.isShowingCreateTapForm) {
          this.props.router.navigate("/taps/mytaps");
        }
      }
    );
  };

  redirectToHistoryModalView = (DAG, event) => {
    // Prevent any parent click events from interfering
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    console.log("History modal triggered for DAG ID: ", DAG.id);
    this.props.router.navigate(`/taps/mytaps?history_modal=${DAG.id}`);
  };

  updateSearchConnectorsKeyword = (e) => {
    this.setState({ searchConnectorsKeyword: e.target.value });
  };
  handleClearSearchConnectorsKeyword = () => {
    this.setState({ searchConnectorsKeyword: "" });
  };

  filterJobNames = (DAG) => {
    const target = DAG.id;
    if (this.state.jobNameFilters) {
      if (target.toLowerCase().includes(this.state.jobNameFilters.toLowerCase())) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  filterByColumn = (DAG, column, values) => {
    return !values.length || values.includes(DAG[column]);
  };

  toggleFilter = (columnName, values) => {
    this.setState({filters: {...this.state.filters, [columnName]: values}, currentPage: 1});
  }

  onSortColumn = (column) => {
    const tasks = this.state.mytasks.map((task) => ({ ...task }));
    let isAsc = true;

    if (this.state.sortedColumn.column === column) {
      isAsc = !this.state.sortedColumn.isAsc;
    }

    this.setState({
      mytasks: tasks.sort((a, b) => {
        if (isAsc) {
          return a[column]?.toLowerCase() < b[column]?.toLowerCase() ? 1 : -1;
        } else {
          return b[column]?.toLowerCase() < a[column]?.toLowerCase() ? 1 : -1;
        }
      }),
    });
    this.setState({ sortedColumn: { column, isAsc } });
  };

  renderStatusIcon = (status) => {
    if (status === "failed" || status === "cancelled") {
      return <FailedIcon style={{ width: "16px", height: "16px" }} />;
    } else if (status === "success") {
      return <SuccessIcon style={{ width: "16px", height: "16px" }} />;
    } else if (status === "queued") {
      return <QueuedIcon style={{ width: "16px", height: "16px" }} />;
    } else if (status === "running" || status === "waiting") {
      return (
        <Lottie
          animationData={runningIcon}
          loop
          style={{ width: "16px", height: "16px" }}
        />
      );
    } else {
      return null;
    }
  }

  renderProviderLogo = (provider) => {
    const logoSrc = provider === "Fivetran"
      ? fivetranlogo
      : provider === "AB Hosted"
      ? airbytelogo
      : provider.startsWith("custom_")
      ? djlogo
      : djlogo;

    return (
      <img 
        src={logoSrc} 
        alt={provider} 
        style={{ 
          width: "20px", 
          height: "20px", 
          objectFit: "contain"
        }}
      />
    );
  }

  renderSourceLogo = (source) => {
    // Find the task that matches this source to get its logo
    const task = this.state.mytasks.find(t => t.source === source);
    if (task && task.logo) {
      return (
        <img 
          src={task.logo} 
          alt={source} 
          style={{ 
            width: "20px", 
            height: "20px", 
            borderRadius: "2px",
            objectFit: "contain"
          }}
        />
      );
    }
    return null;
  }

  render() {
    const { navigate } = this.props.router;
    return (
      <div>
        <LoadingBar color="#0245a0" progress={this.state.progress} />
        <div className="container-fluid py-3">
          <Helmet title="Datajolt | Data Taps" />
          <Tab.Container id="taps-tabs" activeKey={this.state.activeTab}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                margin: "12px 8px",
                height: "45px",
              }}
            >
              <h4 style={{ marginBottom: 0 }}>
                <b style={{ color: "#090E47", marginRight: "10px" }}>
                  My Data Taps
                  {!this.state.loading_mytaps
                    ? " (" + this.state.mytasks.length + ")"
                    : ""}
                </b>
                <OverlayTrigger
                  trigger="click"
                  placement="bottom"
                  overlay={
                    <Popover id={`popover-positioned-bottom`}>
                      <Popover.Header as="h3">
                        {"What are Data Taps?"}
                      </Popover.Header>
                      <Popover.Body>
                        Data Taps are source systems creating your business
                        data.
                        <br />
                        <br />
                        This page allows you to create a data refresh from your
                        source systems to your DWH so your data can then be
                        transformed and analysed.
                      </Popover.Body>
                    </Popover>
                  }
                >
                  <DetailsIcon />
                </OverlayTrigger>{" "}
              </h4>

              {this.state.activeTab === "mytaps" && (
                <div
                  style={{
                    display: "flex",
                    marginLeft: "auto",
                    alignItems: "center",
                    gap: 10,
                  }}
                >
                  {this.state.isShowingCreateTapForm &&
                  this.state.logo &&
                  this.state.selected_tap ? (
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <img
                        style={{
                          width: "50px",
                          height: "50px",
                          objectFit: "contain",
                        }}
                        src={this.state.logo}
                      />
                      <b
                        style={{
                          marginBottom: "0",
                          fontWeight: "bold",
                          color: "#090E47",
                          fontSize: "18px",
                        }}
                      >
                        {this.state.selected_tap}
                      </b>
                    </span>
                  ) : (
                    <>
                      <Tooltip title="Refresh Taps" placement="bottom">
                        <div
                          className="me-1 mb-1 mr-2"
                          disabled={this.state.loading}
                          onClick={() => this.componentDidMount()}
                        >
                          {this.state.loading_mytaps ? (
                            <CircularProgress size={16} sx={{ color: "#2c49fc" }} />
                          ) : (
                            <RefreshIcon />
                          )}
                        </div>
                      </Tooltip>
                      <Button
                        variant="contained"
                        onClick={this.toggleCreateTapForm}
                        sx={{
                          fontSize: "11px",
                          fontWeight: 500,
                          height: "32px",
                          padding: "0 16px",
                          textTransform: "none",
                          borderRadius: "6px",
                          background: "#2D49FD",
                          border: "1px solid #2D49FD",

                          "&:hover": {
                            opacity: 0.9
                          }
                        }}
                      >
                        Create a Tap{" "}
                        <Icon.RefreshCw
                          style={{ marginLeft: "5px" }}
                          width={14}
                          color="white"
                        />
                      </Button>
                    </>
                  )}
                </div>
              )}
            </div>
            <Tab.Content>
              <Tab.Pane eventKey="mytaps">
                <hr style={{ margin: "0 8px" }} />
                {!this.state.loading_mytaps &&
                this.state.mytasks.length == 0 ? (
                  <div style={{
                    backgroundColor: '#ffffff',
                    borderRadius: '8px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                    padding: '60px 40px',
                    textAlign: 'center',
                    marginLeft: '8px',
                    marginRight: '8px',
                  }}>
                    <div style={{
                      marginBottom: '16px',
                    }}>
                      <Icon.RefreshCw size={48} color="#6c757d" />
                    </div>
                    <h3 style={{
                      fontSize: '18px',
                      fontWeight: '600',
                      color: '#293042',
                      margin: '0 0 8px 0',
                      fontFamily: "'Poppins', sans-serif",
                    }}>No data taps yet</h3>
                    <p style={{
                      fontSize: '14px',
                      color: '#6c757d',
                      margin: '0',
                      fontFamily: "'Poppins', sans-serif",
                    }}>Create your first data tap to get started</p>
                  </div>
                ) : (
                  <>
                    <div style={{ margin: "8px 8px" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "12px", flexWrap: "wrap", justifyContent: "space-between" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
                          <Box 
                            sx={{ 
                              width: "200px",
                              "& .MuiOutlinedInput-root": {
                                height: "32px",
                                minHeight: "32px"
                              },
                              "& .MuiInputBase-input": {
                                height: "32px",
                                padding: "0 14px",
                                lineHeight: "32px"
                              },
                              "& .MuiFormControl-root": {
                                height: "32px"
                              }
                            }}
                          >
                            <SearchJobs
                              onFilterChange={(filters) => this.setState({ jobNameFilters: filters, currentPage: 1 })}
                              filter={this.state.jobNameFilters}
                              isSearchOpen={true}
                              toggleSearch={() => {}}
                              placeholder="Search Taps..."
                              size="small"
                            />
                          </Box>

                          <FormControl size="small" sx={{ minWidth: 120 }}>
                            <InputLabel sx={{ fontSize: "10px", fontWeight: 400 }}>Provider</InputLabel>
                            <Select
                              multiple
                              value={this.state.filters.provider}
                              onChange={(e) => this.toggleFilter("provider", e.target.value)}
                              input={<OutlinedInput label="Provider" />}
                              renderValue={() => this.state.filters.provider.length > 0 ? `Provider (${this.state.filters.provider.length})` : "Provider"}
                              MenuProps={{
                                PaperProps: {
                                  style: {
                                    maxHeight: 400,
                                    marginTop: 4,
                                    padding: 0,
                                    overflow: 'hidden',
                                  },
                                  sx: {
                                    '& .MuiList-root': {
                                      padding: 0,
                                      overflow: 'auto',
                                      maxHeight: 400,
                                    }
                                  }
                                },
                                anchorOrigin: {
                                  vertical: 'bottom',
                                  horizontal: 'left',
                                },
                                transformOrigin: {
                                  vertical: 'top',
                                  horizontal: 'left',
                                },
                              }}
                              sx={{ 
                                maxWidth: 140,
                                fontSize: "10px",
                                fontWeight: 400,
                                "& .MuiSelect-select": {
                                  fontSize: "10px",
                                  fontWeight: 400
                                }
                              }}
                            >
                              {this.state.loading_mytaps && (
                                <MenuItem disabled sx={{ 
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  padding: "40px 16px",
                                  fontSize: "10px",
                                  fontWeight: 400,
                                  color: "#6b7280"
                                }}>
                                  <div style={{ 
                                    display: "flex", 
                                    flexDirection: "column", 
                                    alignItems: "center", 
                                    gap: "12px" 
                                  }}>
                                    <CircularProgress size={20} sx={{ color: "#2c49fc" }} />
                                    <span>Loading providers...</span>
                                  </div>
                                </MenuItem>
                              )}
                              
                              {!this.state.loading_mytaps && Array.from(new Set(this.state.mytasks.map(t => t.provider))).sort().map(provider => (
                                <MenuItem key={provider} value={provider} sx={{ 
                                  fontSize: "10px", 
                                  fontWeight: 400, 
                                  wordBreak: "break-all",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center"
                                }}>
                                  <span>{provider}</span>
                                  {this.renderProviderLogo(provider)}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>

                          <FormControl size="small" sx={{ minWidth: 120 }}>
                            <InputLabel sx={{ fontSize: "10px", fontWeight: 400 }}>Source</InputLabel>
                            <Select
                              multiple
                              value={this.state.filters.source}
                              onChange={(e) => this.toggleFilter("source", e.target.value)}
                              input={<OutlinedInput label="Source" />}
                              renderValue={() => this.state.filters.source.length > 0 ? `Source (${this.state.filters.source.length})` : "Source"}
                              MenuProps={{
                                PaperProps: {
                                  style: {
                                    maxHeight: 400,
                                    marginTop: 4,
                                    padding: 0,
                                    overflow: 'hidden',
                                  },
                                  sx: {
                                    '& .MuiList-root': {
                                      padding: 0,
                                      overflow: 'auto',
                                      maxHeight: 400,
                                    }
                                  }
                                },
                                anchorOrigin: {
                                  vertical: 'bottom',
                                  horizontal: 'left',
                                },
                                transformOrigin: {
                                  vertical: 'top',
                                  horizontal: 'left',
                                },
                              }}
                              sx={{ 
                                maxWidth: 140,
                                fontSize: "10px",
                                fontWeight: 400,
                                "& .MuiSelect-select": {
                                  fontSize: "10px",
                                  fontWeight: 400
                                }
                              }}
                            >
                              {this.state.loading_mytaps && (
                                <MenuItem disabled sx={{ 
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  padding: "40px 16px",
                                  fontSize: "10px",
                                  fontWeight: 400,
                                  color: "#6b7280"
                                }}>
                                  <div style={{ 
                                    display: "flex", 
                                    flexDirection: "column", 
                                    alignItems: "center", 
                                    gap: "12px" 
                                  }}>
                                    <CircularProgress size={20} sx={{ color: "#2c49fc" }} />
                                    <span>Loading sources...</span>
                                  </div>
                                </MenuItem>
                              )}
                              
                              {!this.state.loading_mytaps && Array.from(new Set(this.state.mytasks.map(t => t.source))).sort().map(source => (
                                <MenuItem key={source} value={source} sx={{ 
                                  fontSize: "10px", 
                                  fontWeight: 400, 
                                  wordBreak: "break-all",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center"
                                }}>
                                  <span>{source}</span>
                                  {this.renderSourceLogo(source)}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>

                          <FormControl size="small" sx={{ minWidth: 120 }}>
                            <InputLabel sx={{ fontSize: "10px", fontWeight: 400 }}>Status</InputLabel>
                            <Select
                              multiple
                              value={this.state.filters.status}
                              onChange={(e) => this.toggleFilter("status", e.target.value)}
                              input={<OutlinedInput label="Status" />}
                              renderValue={() => this.state.filters.status.length > 0 ? `Status (${this.state.filters.status.length})` : "Status"}
                              MenuProps={{
                                PaperProps: {
                                  style: {
                                    maxHeight: 400,
                                    marginTop: 4,
                                    padding: 0,
                                    overflow: 'hidden',
                                  },
                                  sx: {
                                    '& .MuiList-root': {
                                      padding: 0,
                                      overflow: 'auto',
                                      maxHeight: 400,
                                    }
                                  }
                                },
                                anchorOrigin: {
                                  vertical: 'bottom',
                                  horizontal: 'left',
                                },
                                transformOrigin: {
                                  vertical: 'top',
                                  horizontal: 'left',
                                },
                              }}
                              sx={{ 
                                maxWidth: 140,
                                fontSize: "10px",
                                fontWeight: 400,
                                "& .MuiSelect-select": {
                                  fontSize: "10px",
                                  fontWeight: 400
                                }
                              }}
                            >
                              {this.state.loading_mytaps && (
                                <MenuItem disabled sx={{ 
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  padding: "40px 16px",
                                  fontSize: "10px",
                                  fontWeight: 400,
                                  color: "#6b7280"
                                }}>
                                  <div style={{ 
                                    display: "flex", 
                                    flexDirection: "column", 
                                    alignItems: "center", 
                                    gap: "12px" 
                                  }}>
                                    <CircularProgress size={20} sx={{ color: "#2c49fc" }} />
                                    <span>Loading statuses...</span>
                                  </div>
                                </MenuItem>
                              )}
                              
                              {!this.state.loading_mytaps && Array.from(new Set(this.state.mytasks.map(t => t.status))).map(status => (
                                <MenuItem key={status} value={status} sx={{ 
                                  fontSize: "10px", 
                                  fontWeight: 400, 
                                  wordBreak: "break-all",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center"
                                }}>
                                  <span>{status || 'No status'}</span>
                                  {this.renderStatusIcon(status)}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>
                      </div>

                      {(this.state.filters.provider.length + this.state.filters.source.length + this.state.filters.status.length + (this.state.jobNameFilters ? 1 : 0)) > 0 && (
                        <div style={{ marginBottom: "16px" }}>
                          <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
                            <span style={{ fontSize: "10px", fontWeight: 400 }}>Active filters:</span>
                            
                            {this.state.jobNameFilters && (
                              <span style={{
                                backgroundColor: "#eff6ff",
                                color: "#1d4ed8",
                                padding: "4px 8px",
                                borderRadius: "16px",
                                fontSize: "10px",
                                fontWeight: 400,
                                display: "flex",
                                alignItems: "center",
                                gap: "4px"
                              }}>
                                Tap Name: {this.state.jobNameFilters}
                                <Icon.X 
                                  size={14} 
                                  style={{ cursor: "pointer" }} 
                                  onClick={() => this.setState({ jobNameFilters: "", currentPage: 1 })}
                                />
                              </span>
                            )}
                            
                            {this.state.filters.provider.map(provider => (
                              <span key={provider} style={{
                                backgroundColor: "#eff6ff",
                                color: "#1d4ed8",
                                padding: "4px 8px",
                                borderRadius: "16px",
                                fontSize: "10px",
                                fontWeight: 400,
                                display: "flex",
                                alignItems: "center",
                                gap: "4px"
                              }}>
                                Provider: {provider}
                                <Icon.X 
                                  size={14} 
                                  style={{ cursor: "pointer" }} 
                                  onClick={() => this.toggleFilter("provider", this.state.filters.provider.filter(p => p !== provider))}
                                />
                              </span>
                            ))}
                            
                            {this.state.filters.source.map(source => (
                              <span key={source} style={{
                                backgroundColor: "#eff6ff",
                                color: "#1d4ed8",
                                padding: "4px 8px",
                                borderRadius: "16px",
                                fontSize: "10px",
                                fontWeight: 400,
                                display: "flex",
                                alignItems: "center",
                                gap: "4px"
                              }}>
                                Source: {source}
                                <Icon.X 
                                  size={14} 
                                  style={{ cursor: "pointer" }} 
                                  onClick={() => this.toggleFilter("source", this.state.filters.source.filter(s => s !== source))}
                                />
                              </span>
                            ))}
                            
                            {this.state.filters.status.map(status => (
                              <span key={status} style={{
                                backgroundColor: "#eff6ff",
                                color: "#1d4ed8",
                                padding: "4px 8px",
                                borderRadius: "16px",
                                fontSize: "10px",
                                fontWeight: 400,
                                display: "flex",
                                alignItems: "center",
                                gap: "4px"
                              }}>
                                Status: {status || 'No status'}
                                <Icon.X 
                                  size={14} 
                                  style={{ cursor: "pointer" }} 
                                  onClick={() => this.toggleFilter("status", this.state.filters.status.filter(s => s !== status))}
                                />
                              </span>
                            ))}
                            
                            <Button
                              variant="text"
                              size="small"
                              onClick={() => this.setState({ 
                                filters: { provider: [], source: [], status: [] },
                                jobNameFilters: "",
                                currentPage: 1
                              })}
                              sx={{ fontSize: "10px", fontWeight: 400, color: "#6b7280" }}
                            >
                              Clear all
                            </Button>
                          </div>
                        </div>
                      )}
                    </div>

                    <Table
                      headings={[
                        {
                          width: "6%",
                          columnName: "logo",
                          isSortable: false,
                          Children: () => <></>,
                        },
                        {
                          columnName: "id",
                          isSortable: true,
                          Children: ({ children }) => (
                            <span className="d-flex align-items-center h-100">
                              Job Name
                              {children}
                            </span>
                          ),
                        },
                        {
                          columnName: "source",
                          isSortable: true,
                          Children: ({ children }) => (
                            <span className="d-flex align-items-center h-100">
                              Source
                              {children}
                            </span>
                          ),
                        },
                        {
                          columnName: "schema",
                          isSortable: true,
                          Children: ({ children }) => (
                            <span className="d-flex align-items-center h-100">
                              Schema
                              {children}
                            </span>
                          ),
                        },
                        {
                          columnName: "last_started",
                          isSortable: true,
                          Children: ({ children }) => (
                            <span className="d-flex align-items-center h-100">
                              last started
                              {children}
                            </span>
                          ),
                        },
                        {
                          columnName: "last_ended",
                          isSortable: true,
                          Children: ({ children }) => (
                            <span className="d-flex align-items-center h-100">
                              last ended
                              {children}
                            </span>
                          ),
                        },
                        {
                          columnName: "status",
                          isSortable: true,
                          Children: ({ children }) => (
                            <span className="d-flex align-items-center h-100">
                              status
                              {children}
                            </span>
                          ),
                        },
                        {
                          columnName: "provider",
                          isSortable: false,
                          Children: ({ children }) => (
                            <span className="d-flex align-items-center h-100">
                              provider
                              {children}
                            </span>
                          ),
                        },
                        {
                          width: "6%",
                          columnName: "actions",
                          isSortable: false,
                          Children: () => "actions",
                        },
                      ]}
                      rows={this.paginateArray(
                        this.state.mytasks?.filter(
                          (DAG) =>
                            this.filterJobNames(DAG) &&
                            this.filterByColumn(DAG, "provider", this.state.filters.provider) &&
                            this.filterByColumn(DAG, "source", this.state.filters.source) && 
                            this.filterByColumn(DAG, "status", this.state.filters.status)
                        )
                      ).map((DAG, index) => ({
                        key: `${DAG.id}${index}`,
                        columns: [
                          {
                            type: "image",
                            logo: DAG.logo,
                          },
                          {
                            type: "text",
                            text: DAG.id,
                          },
                          {
                            type: DAG.spreadsheet_id ? "component" : "text",
                            text: DAG.source,
                            component: DAG.spreadsheet_id ? (
                              <div style={{ display: "flex", alignItems: "center" }}>
                                <span>{DAG.source}</span>
                                <a
                                  href={DAG.spreadsheet_id}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  onClick={(e) => e.stopPropagation()}
                                  style={{
                                    marginLeft: '8px',
                                    color: '#2D49FD',
                                  }}
                                >
                                  <Icon.ExternalLink size={12} />
                                </a>
                              </div>
                            ) : undefined,
                          },
                          {
                            type: "text",
                            text: DAG.schema,
                          },
                          {
                            type: "date",
                            date: DAG.last_started,
                          },
                          {
                            type: "date",
                            date: DAG.last_ended,
                          },
                          {
                            type: "status",
                            key: DAG.status,
                          },
                          {
                            type: "component",
                            component: (
                              <img
                                src={
                                  DAG.provider === "Fivetran"
                                    ? fivetranlogo
                                    : DAG.provider == "AB Hosted"
                                    ? airbytelogo
                                    : djlogo
                                }
                                height="30px"
                                alt={`${DAG.provider || "Default"} Logo`}
                                style={{ display: "block", objectFit: "contain" }}
                              />
                            ),
                          },
                          {
                            type: "component",
                            component: (
                              <HorizontalDropdownMenu
                                items={[
                                  {
                                  tooltipTitle: DAG.provider === "datajolt_custom" ? "Custom taps cannot be triggered manually. Schedule tap as part of a DAG instead." : "Trigger Tap",
                                    disabled: DAG.status === "running" || DAG.provider === "datajolt_custom",
                                    variant: "no-outline-success",
                                    onClick: (e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      DAG.provider == "Fivetran"
                                        ? this.triggerFivetran(
                                            DAG.datajolt_task_id,
                                            DAG.id
                                          )
                                        : this.triggerAirbyteTap(
                                            DAG.id,
                                            DAG.connectionID,
                                            DAG.datajolt_task_id
                                          );
                                    },
                                    children:
                                      DAG.status === "running" ? (
                                        <CircularProgress
                                          size={12}
                                          sx={{ color: "#2c49fc" }}
                                        />
                                      ) : (
                                        <PlayIcon />
                                      ),
                                  },
                                  {
                                    tooltipTitle: "Edit Tap",
                                    disabled: DAG.provider !== "AB Hosted" && DAG.provider !== "datajolt_custom",
                                    className: "me-1 mb-1",
                                    variant: "no-outline",
                                    onClick: (e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      navigate(
                                        "/taps/mytaps?edit_tap=" + DAG.id
                                      );
                                    },
                                    children: (
                                      <SettingsIcon className="bigger-svg" />
                                    ),
                                  },
                                  {
                                    tooltipTitle: "Open History",
                                    disabled: false,
                                    className: "me-1 mb-1",
                                    variant: "no-outline",
                                    onClick: (e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      this.redirectToHistoryModalView(DAG, e);
                                    },
                                    children: <OptionsIcon />,
                                  },
                                  {
                                    tooltipTitle: "Stop Tap",
                                    disabled: false,
                                    className: "me-1 mb-1",
                                    variant: "no-outline-danger",
                                    onClick: (e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      this.handleStopTask(
                                        DAG.id,
                                        DAG.datajolt_task_id
                                      );
                                    },
                                    children: <StopIcon />,
                                  },
                                  {
                                    tooltipTitle: "Delete Tap",
                                    disabled: false,
                                    className: "mb-1",
                                    variant: "no-outline-danger",
                                    onClick: (e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      this.toggleDeleteModal(
                                        DAG.id,
                                        DAG.sourceID,
                                        DAG.logo,
                                        DAG.subtype,
                                        DAG.datajolt_task_id
                                      );
                                    },
                                    children: <CancelIcon />,
                                  },
                                ]}
                              />
                            ),
                          },
                        ],
                      }))}
                      sortedColumn={this.state.sortedColumn}
                      onSortColumn={(columnName) =>
                        this.onSortColumn(columnName)
                      }
                      isLoading={this.state.loading_mytaps}
                    />
                    <TablePagination
                      currentPage={this.state.currentPage}
                      totalPages={this.calculateTotalPages()}
                      updatePageNum={(num) =>
                        this.setState({ currentPage: num })
                      }
                      updatePerPage={(num) => this.setState({ perPage: num })}
                      activeTable={this.state.jobNameFilters}
                    />
                  </>
                )}
              </Tab.Pane>
            </Tab.Content>

            <CustomReportsModal
              isShown={this.state.modal_custom_reports}
              onHide={() => {
                this.setState({ modal_custom_reports: false });
                navigate(
                  `/taps/mytaps?edit_tap=${this.state.selected_for_edit}`
                );
              }}
              onAction={() => this.saveCustomReports()}
              logo={this.state.logo}
              windowInDays={this.state.window_in_days}
              setWindwInDays={(e) =>
                this.setState({
                  window_in_days: parseInt(e.target.value, 10),
                })
              }
              customReports={this.state.custom_reports}
              addCustomReport={() =>
                this.setState({
                  custom_reports: [
                    ...this.state.custom_reports,
                    { name: "", metrics: "", dimensions: "" },
                  ],
                })
              }
              selectedTap={this.state.selected_tap}
              savingNewSpecs={this.state.saving_new_specs}
              updateCustomReport={(i, type, e) =>
                this.updateCustomReport(i, type, e)
              }
              deleteReport={() =>
                this.setState({
                  custom_reports: this.state.custom_reports.filter(
                    (item) => item.id !== custom_report.id
                  ),
                })
              }
            />

            <DeleteConnectorModal
              isShown={this.state.modal_delete_connector}
              onHide={() => this.toggleDeleteModal()}
              onAction={() =>
                this.deleteDAG(
                  this.state.delete_datajolt_task_id,
                  this.state.delete_id
                )
              }
              deleteData={{
                logo: this.state.delete_logo,
                deleting: this.state.deleting,
              }}
              text={{
                bold: `${this.state.delete_name} (${this.state.delete_id})`,
                regular: "data tap.",
              }}
            />
          </Tab.Container>

          <CSSTransition
            in={this.state.isShowingDagHistoryTable}
            classNames="form-tab"
            timeout={300}
            unmountOnExit
          >
            <DagHistory
              dagList={Boolean(this.state.mytasks.length) && this.state.mytasks.map(task => ({
                ...task,
                dag_id: task.datajolt_task_id
              }))}
              hideTaskTimeline={true}
              show_logs={true}
              onClose={() => {
                this.setState({
                  isShowingDagHistoryTable: false,
                });
                navigate("/taps/mytaps");
              }}
            />
          </CSSTransition>

          <CSSTransition
            in={this.state.isShowingCreateTapForm}
            classNames="form-tab"
            timeout={300}
            unmountOnExit
          >
            <TapCreatorForm
              getMyTaps={this.getMyTaps}
              mytasks={this.state.mytasks} // Pass mytasks as a prop
              setSelectedTapData={this.setSelectedTapData}
              isEditingTap={new URLSearchParams(window.location.search).get(
                "edit_tap"
              )}
              toggleCreateTapForm={this.toggleCreateTapForm}
            />
          </CSSTransition>
        </div>
      </div>
    );
  }
}

export default WithRouter(NewTap);
